export enum AllocationType {
    Factory = 1,
    Customer = 2
}



// WEBPACK FOOTER //
// ./src/app/shared/enums/AllocationType.ts